import { Dataset } from '@app/modules/core/store/models/dataset.model';
import { PopupService } from '../popups';
import { ClusterRenderer, Layer, MapEventsService, MapLayerClusterService, SvgRenderer } from './cluster-renderer';

export const normalClusterSvg = (fillColor: string, borderColor: string) =>
  'data:image/svg+xml;base64,' +
  window.btoa(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
<circle stroke="${borderColor}" stroke-width="8" cx="60" cy="60" opacity="1.0" r="50" fill="${fillColor}"  />
</svg>`);

export const selectedClusterSvg = (fillColor: string, borderColor: string) =>
  'data:image/svg+xml;base64,' +
  window.btoa(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
<circle cx="60" cy="60" opacity="1.0" r="42" fill="${fillColor}" />
<circle stroke="${borderColor}" stroke-width="8" cx="60" cy="60" opacity="1.0" r="42" fill="${fillColor}"  />
<circle stroke="#917AFF" stroke-width="6" cx="60" cy="60" opacity=".6" r="44" fill="none" />
<circle stroke="#917AFF" stroke-width="6" cx="60" cy="60" opacity=".55" r="47" fill="none" />
<circle stroke="#917AFF" stroke-width="6" cx="60" cy="60" opacity=".5" r="50" fill="none" />
<circle stroke="#917AFF" stroke-width="6" cx="60" cy="60" opacity=".45" r="53" fill="none" />
<circle stroke="#917AFF" stroke-width="6" cx="60" cy="60" opacity=".4" r="56" fill="none" />
</svg>`);

export class StandardClusterRenderer extends ClusterRenderer {
  constructor(
    protected layer: Layer,
    protected dataset: Dataset,
    protected mapEventsService: MapEventsService,
    protected clusterService: MapLayerClusterService,
    protected popup: PopupService,
    protected isWorkflowLayerSection: boolean,
    protected normalSvgRenderer?: SvgRenderer,
    protected selectedSvgRenderer?: SvgRenderer
  ) {
    super(layer, dataset, mapEventsService, clusterService, popup, isWorkflowLayerSection, normalSvgRenderer ?? normalClusterSvg, selectedSvgRenderer ?? selectedClusterSvg);
  }
}
